import React from "react";
import { useOutletContext } from "react-router-dom";
import { useMentalPatterns } from "../mentalPatterns/MentalPatternsContext.js";
import {
  MIN_INSIGHTS_FOR_PATTERNS,
  INSUFFICIENT_INSIGHTS_MESSAGE
} from "../../constants/mentalPatternsHub.js";
import { BEHAVIORAL_PATTERNS_TITLE } from "../../constants/routes.js";
import PatternInsightSummary from "../mentalPatterns/PatternInsightSummary.js";
import MentalPatternsDashboardCards from "../mentalPatterns/MentalPatternsDashboardCards.js";
import LockedPatternTease from "../mentalPatterns/LockedPatternTease.js";
import {
  SuggestedReflectionToday,
  ScoreImpactFactors,
  MentalLoopsDetected
} from "../mentalPatterns/MentalPatternsHubSections.js";
import EmotionDistributionSection from "./EmotionDistributionSection.js";

const BehavioralPatternsHub = () => {
  const { isSubscriber, verifiedEmail } = useOutletContext() || {};
  const { insights, isLoading, error, retry, totalReflections, hubInsights, lockedPatternTease } =
    useMentalPatterns();
  const hasEnoughInsights = totalReflections >= MIN_INSIGHTS_FOR_PATTERNS;
  const showLockedTease = !isSubscriber && hasEnoughInsights;

  if (isLoading) {
    return (
      <div className="mp-hub">
        <header className="mp-hub__header">
          <h1 className="mp-hub__title">{BEHAVIORAL_PATTERNS_TITLE}</h1>
        </header>
        <p>Loading pattern reports…</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="mp-hub">
        <header className="mp-hub__header">
          <h1 className="mp-hub__title">{BEHAVIORAL_PATTERNS_TITLE}</h1>
        </header>
        <div className="login-error">
          <p>{error}</p>
          <button type="button" className="link-button" onClick={retry}>
            Retry
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="mp-hub behavioral-patterns-hub">
      <header className="mp-hub__header">
        <h1 className="mp-hub__title">{BEHAVIORAL_PATTERNS_TITLE}</h1>
      </header>

      <EmotionDistributionSection insights={insights} />

      {hasEnoughInsights ? (
        showLockedTease ? (
          <>
            <LockedPatternTease tease={lockedPatternTease} verifiedEmail={verifiedEmail} />
            <SuggestedReflectionToday prompt={hubInsights?.suggestedPrompt} />
          </>
        ) : (
          <>
            <PatternInsightSummary summary={hubInsights?.summary} />
            <MentalLoopsDetected loops={hubInsights?.loops} />
            <MentalPatternsDashboardCards />
            <div className="mp-hub__grid">
              <SuggestedReflectionToday prompt={hubInsights?.suggestedPrompt} />
              <ScoreImpactFactors />
            </div>
          </>
        )
      ) : (
        <div className="mp-hub__insufficient" role="status">
          <p className="mp-hub__insufficient-text">{INSUFFICIENT_INSIGHTS_MESSAGE}</p>
          {totalReflections > 0 ? (
            <p className="mp-hub__insufficient-progress">
              {totalReflections} of {MIN_INSIGHTS_FOR_PATTERNS} reflections recorded for full pattern analysis.
            </p>
          ) : null}
        </div>
      )}
    </div>
  );
};

export default BehavioralPatternsHub;
